"use strict";

exports.__esModule = true;
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * performs requests with axios
 *
 * @param {*} url
 * @param {*} {
 *     onSuccess,
 *     onError,
 *     headers = {
 *       'Content-Type': 'application/json',
 *     ...config
 *   }
 */
const apiCall = (url, {
  onSuccess,
  onError,
  headers = {
    'Content-Type': 'application/json'
  },
  ...config
}) => (0, _axios.default)({
  url,
  ...headers,
  ...config
}).then(response => onSuccess(response)).catch(error => {
  if (onError) {
    onError(error);
  }
});

var _default = apiCall;
exports.default = _default;